var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 2.49902C17.5238 2.49902 22.0016 6.97687 22.0016 12.5006C22.0016 18.0243 17.5238 22.5021 12.0001 22.5021C6.47638 22.5021 1.99854 18.0243 1.99854 12.5006C1.99854 6.97687 6.47638 2.49902 12.0001 2.49902ZM12.0001 3.99902C7.30481 3.99902 3.49854 7.8053 3.49854 12.5006C3.49854 17.1959 7.30481 21.0021 12.0001 21.0021C16.6954 21.0021 20.5016 17.1959 20.5016 12.5006C20.5016 7.8053 16.6954 3.99902 12.0001 3.99902ZM11.9964 10.9996C12.3761 10.9994 12.6901 11.2813 12.74 11.6473L12.7469 11.7491L12.7505 17.2507C12.7508 17.6649 12.4152 18.0009 12.001 18.0012C11.6213 18.0014 11.3073 17.7195 11.2574 17.3535L11.2505 17.2517L11.2469 11.7501C11.2467 11.3359 11.5822 10.9999 11.9964 10.9996ZM12.0005 7.50184C12.5521 7.50184 12.9992 7.94896 12.9992 8.5005C12.9992 9.05205 12.5521 9.49917 12.0005 9.49917C11.449 9.49917 11.0019 9.05205 11.0019 8.5005C11.0019 7.94896 11.449 7.50184 12.0005 7.50184Z",
    fill: "#717A85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableInfo);
export default __webpack_public_path__ + "static/media/table-info.ce90e9416fb33761ce4fef6239cb6913.svg";
export { ForwardRef as ReactComponent };